import styled from 'styled-components';

import { styledIf, colors } from '@ovpn-ui/styles';

export const MenuOption = styled.div<{ $disabled?: boolean }>`
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    padding: 8px 16px;
    overflow-x: hidden;

    font-size: 14px;
    white-space: nowrap;

    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: ${colors.neutralBg};
    }

    .option-name {
        color: ${colors.neutralTextBody};
    }

    .option-description {
        display: inline-block;
        max-width: 300px;
        margin-top: 6px;

        color: ${colors.neutralTextSubtitle};
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        white-space: normal;
        text-align: left;
        vertical-align: top;
        word-break: break-word;

        .icon-tabler-alert-circle {
            margin-top: -2px;
            margin-right: 8px;

            color: ${colors.brandOrange};
        }
    }

    &:not(:last-child) {
        margin-bottom: 5px;
    }

    ${styledIf('$disabled')`
        flex-direction: column;
        height: auto;
        cursor: default;
    `}
`;
